module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/ielts/assets/avatars-e952b26d18f7e38201d95dc3b29254e5.png";